<template>
  <span>
    <main-input-dialog
      :is-visible.sync="computedIsVisible"
      :title-translation="
        $i18n.t('dialog.title.changeDatasourceSrid', { datasource_name: datasourceMetadata.verbose_name })
      "
      agree-text="dialog.agreeSave"
      :is-input-dialog="true"
      @agree="isConfirmDialogLoaded = isConfirmDialogVisible = true"
      :inputs="input"
    >
      <template #[`srid.input`]="slot">
        <v-col cols="6">
          <data-input v-model="srid" clearable v-bind="slot">
            <template #item="{ item, on, attrs }">
              <v-list-item v-show="!item.hidden" v-on="on" v-bind="attrs">
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </data-input>
        </v-col>
      </template>
    </main-input-dialog>
    <main-dialog
      v-if="isConfirmDialogLoaded"
      :is-visible.sync="isConfirmDialogVisible"
      :title="$i18n.t('dialog.title.changeDatasourceSridConfirm')"
      :body="$i18n.t('dialog.body.changeDatasourceSridConfirm')"
      agree-text="dialog.agreeChange"
      :loading="isLoading"
      @agree="handleChangeSrid"
    ></main-dialog>
  </span>
</template>

<script>
import { get, call } from 'vuex-pathify';

import DataInput from '@/components/DataInput';

export default {
  name: 'ChangeDatasourceSridDialog',
  components: {
    DataInput,
    MainDialog: () => import('@/components/MainDialog'),
    MainInputDialog: () => import('@/components/MainInputDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    datasourceMetadata: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    srid: null,
    notSupportedSrid: null,
    isLoading: false,
    isConfirmDialogLoaded: false,
    isConfirmDialogVisible: false,
  }),
  computed: {
    coordinatesEpsgs: get('map/coordinatesEpsgs'),
    coordinatesEpsgsArray() {
      return Object.values(this.coordinatesEpsgs).map(epsgData => ({
        text: epsgData.text,
        value: epsgData.srid,
      }));
    },
    computedIsVisible: {
      get() {
        if (this.isVisible) this.getCurrentSrid(this.datasourceMetadata);
        return this.isVisible;
      },
      set(nV) {
        if (!nV) this.notSupportedSrid = null;
        this.$emit('update:isVisible', nV);
      },
    },
    input() {
      return [
        {
          name: 'srid',
          translationPath: 'dialog.body.coordinateSystem',
          hideDetails: true,
          rules: [v => (!!v || v == '0') && this.notSupportedSrid?.value !== v],
          items: [...(this.notSupportedSrid ? [this.notSupportedSrid] : []), ...this.coordinatesEpsgsArray],
          dataType: {
            name: 'select',
          },
        },
      ];
    },
  },
  methods: {
    transformDatasource: call('layers/transformDatasource'),
    getCurrentSrid(datasourceMetadata) {
      if (!this.coordinatesEpsgsArray.find(srid => srid.value === datasourceMetadata.srid)) {
        this.notSupportedSrid = {
          text: `EPSG:${datasourceMetadata.srid}`,
          value: datasourceMetadata.srid,
          hidden: true,
        };
      }
      this.srid = datasourceMetadata.srid;
    },
    async handleChangeSrid() {
      this.isLoading = true;
      try {
        await this.transformDatasource({
          datasource: this.datasourceMetadata.name,
          payload: {
            target_srid: this.srid,
          },
        });
        this.isConfirmDialogVisible = this.computedIsVisible = false;
      } catch {
        this.isConfirmDialogVisible = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
